import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import {
  CdeDataTypesResponse,
  CdeProgramsResponse,
  ConfiguredDataElement,
  ConfiguredDataElementsResponse,
  ConfiguredDataElementsPagedResponse,
} from '../../shared/models/program.models';
import { PageParams } from '../../shared/models/pagination.models';

@Injectable({ providedIn: 'root' })
export class DataElementService {
  private http = inject(HttpClient);
  private apiUrl = environment.apiUrl;

  getCdeDataTypes() {
    return this.http.get<CdeDataTypesResponse>(`${this.apiUrl}/api/cde-data-types`);
  }

  getDataElements() {
    return this.http.get<ConfiguredDataElementsResponse>(
      `${this.apiUrl}/api/configured-data-elements`,
    );
  }

  getDataElementsPaged(params: PageParams) {
    let httpParams = new HttpParams()
      .set('pageSize', params.pageSize ?? 10)
      .set('pageIndex', params.pageIndex ?? 0);
    if (params.filter) httpParams = httpParams.set('filter', params.filter);
    return this.http.get<ConfiguredDataElementsPagedResponse>(
      `${this.apiUrl}/api/configured-data-elements`,
      { params: httpParams },
    );
  }

  getDataElementById(id: string) {
    return this.http.get<ConfiguredDataElement>(
      `${this.apiUrl}/api/configured-data-elements/${id}`,
    );
  }

  createDataElement(payload: Omit<ConfiguredDataElement, 'id'>) {
    return this.http.post<ConfiguredDataElement>(
      `${this.apiUrl}/api/configured-data-elements`,
      payload,
    );
  }

  updateDataElement(payload: ConfiguredDataElement) {
    return this.http.put<ConfiguredDataElement>(
      `${this.apiUrl}/api/configured-data-elements`,
      payload,
    );
  }

  /** With `situationCategoryIds`, the API also returns the CDEs linked to those situation categories. */
  getCdePrograms(programId: string, level: number, situationCategoryIds: string[] = []) {
    let params = new HttpParams().set('programId', programId).set('level', level);
    for (const id of situationCategoryIds) params = params.append('situationCategoryIds', id);
    return this.http.get<CdeProgramsResponse>(`${this.apiUrl}/api/cde-programs`, { params });
  }

  deleteDataElement(id: string) {
    return this.http.delete<void>(`${this.apiUrl}/api/configured-data-elements/${id}`);
  }
}
